import authorization from "@/components/webportals/authorization/authorization.js";
import axios from "axios";
export default {
  log
};

async function log(to) {
  var payload = {
    page_name: to.name,
    path: to.path,
    taxid: localStorage.STID || "",
    usercode: localStorage.Username || ""
  };
  var dataEncode = await authorization.encodeData(payload);
  var auth = await authorization.gentoken(localStorage.STID || "");
  var headers = { Authorization: "Bearer " + auth };
  let result = await axios.post(
    process.env.API_MAIN + "/web_activity_log",
    { data: dataEncode },
    { headers }
  );
}



// WEBPACK FOOTER //
// ./src/functions/activityLog.js